var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavMenuSvg({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.1791 18.5002C32.1791 17.9644 31.7442 17.5295 31.2084 17.5295H7.91209C7.37627 17.5295 6.94141 17.9644 6.94141 18.5002C6.94141 19.036 7.37627 19.4709 7.91209 19.4709H31.2084C31.7442 19.4709 32.1791 19.036 32.1791 18.5002Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.94334 11.7053H23.7684C24.3043 11.7053 24.7391 11.2704 24.7391 10.7346C24.7391 10.1988 24.3043 9.76392 23.7684 9.76392H6.94334C6.40752 9.76392 5.97266 10.1988 5.97266 10.7346C5.97266 11.2704 6.40752 11.7053 6.94334 11.7053Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2087 25.2949C31.7445 25.2949 32.1793 25.7298 32.1793 26.2656C32.1793 26.8014 31.7445 27.2363 31.2087 27.2363H19.5605C19.0247 27.2363 18.5898 26.8014 18.5898 26.2656C18.5898 25.7298 19.0247 25.2949 19.5605 25.2949H31.2087Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavMenuSvg);
export default __webpack_public_path__ + "static/media/nav-MenuSVG.ded56bbf11f13332d175d3f4ef744eb3.svg";
export { ForwardRef as ReactComponent };